import {persist} from 'zustand/middleware';
import {create} from 'zustand';

interface Store {
  redirectedContracts: Record<string, string>;
  addContract: (contractId: string, requestId: string) => void;
  removeContract: (requestId: string) => void;
  clear: () => void;
}

export const useRedirectedContractsStore = create<Store>()(
  persist(
    (set) => ({
      redirectedContracts: {} as Record<string, string>,
      addContract(contractId: string, requestId: string) {
        set((state) => ({
          redirectedContracts: {...state.redirectedContracts, [requestId]: contractId},
        }));
      },
      removeContract(requestId: string) {
        set((state) => {
          const redirectedContract = state.redirectedContracts;
          delete redirectedContract[requestId];
          return {
            redirectedContracts: {...redirectedContract},
          };
        });
      },
      clear() {
        set(() => ({redirectedContracts: {}}));
      },
    }),
    {name: 'redirectedContracts'},
  ),
);
